import { Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useEffect, useRef, useState } from "react";
import Category from "../../actions/Catagory";
import Product from "../../actions/product";
import { Autocomplete, CircularProgress, MenuItem } from "@mui/material";
import Controls from "../controls/Controls";
import { Form, useForm } from "../customHelpers/useForm";
import Store from "../../actions/store";
const type = ["Stocked Product", "Service"];
const initialFValues = {
  name: "",
  description: "",
  price: "",
  quantity: "",
  sku: "",
  container: "",
  category: "",
  bar_code: "",
  type: "",
  storeId: "",
  editing: false,
};

const AddProduct = ({
  openPopupUpdate,
  NotifyMessage,
  setOpenPopup,
  recordForEdit,
  getAllProducts,
  edite,
}) => {
  useEffect(() => {
    if (recordForEdit) {
      setValues({
        ...recordForEdit,
        category: recordForEdit.category || "", // Ensure category is set
      });
    }
  }, [recordForEdit]);

  useEffect(() => {
    getAllRoles();
    getAllStores();
  }, []);
  const { addProduct, updateProduct } = Product();
  const [stores, setStores] = useState([]);
  const [categories, setCategories] = useState([]);
  const { viewAllCatagories } = Category();
  const { viewAllStores } = Store();
  const validate = (fieldValues = values) => {
    const temp = { ...errors };
    if ("name" in fieldValues)
      temp.name = fieldValues.name.length != 0 ? "" : "This field is required.";

    if ("sku" in fieldValues)
      temp.sku = fieldValues.sku.length !== 0 ? "" : "This field is required.";
    if ("price" in fieldValues)
      temp.price =
        fieldValues.price.length !== 0 ? "" : "This field is required.";
    if ("price" in fieldValues) {
      temp.price =
        fieldValues.price > 0 ? "" : "Price Value must be More than 0.";
    }
    if ("container" in fieldValues)
      temp.container =
        fieldValues.container.length !== 0 ? "" : "This field is required.";
    if ("quantity" in fieldValues)
      temp.quantity =
        fieldValues.quantity.length !== 0 ? "" : "This field is required.";
    if ("quantity" in fieldValues) {
      temp.quantity =
        fieldValues.quantity > 0 ? "" : "quantity Value must be More than 0.";
    }
    if ("storeId" in fieldValues)
      temp.storeId =
        fieldValues.storeId.length !== 0 ? "" : "This field is required.";

    setErrors({
      ...temp,
    });
    if (fieldValues == values) return Object.values(temp).every((x) => x == "");
  };

  const { values, errors, setValues, handleInputChange, setErrors, resetForm } =
    useForm(initialFValues, true, validate);
  const getAllRoles = () => {
    viewAllCatagories().then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.categorys) {
        setCategories(data.categorys);
      }
    });
  };
  const getAllStores = () => {
    viewAllStores().then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.stores) {
        setStores(data.stores);
      }
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validate()) {
      setValues({ ...values, submitting: true });
      if (edite === false) {
        delete values.logginError;
        delete values.editing;
        addProduct(values).then((data) => {
          if (data.err) {
            setValues({ ...values, submitting: false });
            NotifyMessage({
              message: data.err,
              type: "error",
            });
          } else {
            NotifyMessage({
              message: "Product successfully created",
              type: "success",
            });
            setOpenPopup(false);
            setValues({ ...values, submitting: false });
            getAllProducts();
            resetForm();
          }
        });
      } else {
        delete values.logginError;
        delete values.editing;
        updateProduct(values, values.id).then((data) => {
          if (data.err) {
            setValues({ ...values, submitting: false });
            NotifyMessage({
              message: data.err,
              type: "error",
            });
          } else {
            NotifyMessage({
              message: "Product successfully updated",
              type: "success",
            });
            setOpenPopup(false);
            resetForm();
            setValues({ ...values, submitting: false });
            getAllProducts();
          }
        });
      }
    }
  };
  const firstFieldRef = useRef(null);
  useEffect(() => {
    if (firstFieldRef.current) {
      firstFieldRef.current.focus();
    }
  }, [openPopupUpdate]);
  return (
    <Form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Controls.Input
            name="name"
            label="Name"
            value={values.name}
            onChange={handleInputChange}
            error={errors.name}
            inputRef={firstFieldRef} // Attach the reference here
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Controls.Input
            name="description"
            label="Description"
            value={values.description}
            onChange={handleInputChange}
            error={errors.description}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Controls.Input
            disabled={recordForEdit !== null}
            name="sku"
            label="Sku"
            value={values.sku}
            onChange={handleInputChange}
            error={errors.sku}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Controls.TypeSelect
            name="type"
            label="Type"
            options={type}
            value={values.type}
            onChange={handleInputChange}
            error={errors.type}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Controls.Input
            name="bar_code"
            label="Bar_code"
            value={values.bar_code}
            onChange={handleInputChange}
            error={errors.bar_code}
          />
        </Grid>
        {!openPopupUpdate && (
          <Grid item xs={12} md={6}>
            <Controls.Input
              name="quantity"
              label="Quantity"
              value={values.quantity}
              onChange={handleInputChange}
              error={errors.quantity}
            />
          </Grid>
        )}
        {!openPopupUpdate && (
          <Grid item xs={12} md={6}>
            <Controls.Input
              name="price"
              label="Price"
              type="number"
              value={values.price}
              onChange={handleInputChange}
              error={errors.price}
            />
          </Grid>
        )}
        {!openPopupUpdate && (
          <Grid item xs={12} md={6}>
            <Controls.Input
              name="container"
              label="Container"
              value={values.container}
              onChange={handleInputChange}
              error={errors.container}
            />
          </Grid>
        )}

        <Grid item xs={12} md={6}>
          <Controls.Select
            name="category"
            label="Catagory"
            value={values.category}
            onChange={handleInputChange}
            options={categories}
            error={errors.category}
          />
        </Grid>
        {!openPopupUpdate && (
          <Grid item xs={12} md={6}>
            <Controls.SelectStore
              name="storeId"
              label="Store"
              value={values.storeId}
              onChange={handleInputChange}
              options={stores}
              error={errors.storeId}
            />
          </Grid>
        )}
        <Grid item xs={12} md={6}>
          <div>
            <Controls.Button
              disabled={values.submitting ? true : false}
              text={
                edite == true
                  ? values.submitting
                    ? "Editing..."
                    : "Done"
                  : values.submitting
                  ? "Adding..."
                  : "Add"
              }
             type="submit"
            />
            <Controls.Button
              text={"Cancel"}
              color="default"
              onClick={() => {
                setOpenPopup(false);
              }}
            />
          </div>
        </Grid>
      </Grid>
    </Form>
  );
};

export default AddProduct;
